export default [
    {
        path: '/ambiences/travel-times',
        name: 'ambiences-travel-times',
        component: () => import ('./views/TravelTimeIndex'),
        meta: {
            title: 'Tempo entre locais',
            icon: 'mdi-map-marker-distance',
            breadcrumbs: [
                { text: 'Ambientes', disabled: true },
                { text: 'Tempo entre locais', disabled: true }
            ]
        }
    },
]
